import { TAMLogger } from '@constant/dev-helper';
import html2canvas from 'html2canvas';

/**
 * 下载excel文件
 * @param buffer {ArrayBuffer} 文件流
 * @param filename {string} 文件名 default: '观众列表'
 */
export function downloadExcel(buffer: ArrayBuffer, filename = '观众列表') {
  // prettier-ignore
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const blob = new Blob([buffer], { type: fileType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}

async function fetchBuffer(url: string): Promise<ArrayBuffer> {
  // prettier-ignore
  return fetch(url).then(response => response.arrayBuffer());
}

export async function downloadExcelByFetch(url: string, filename = '观众列表') {
  const buffer = await fetchBuffer(url).catch((err) => {
    TAMLogger.error('downloadExcelByFetch', err);
  });
  if (buffer) {
    downloadExcel(buffer, filename);
  }
}

/** 将blob文件保存到本地 */
export function downloadBlob(blob: Blob | string, filename: string) {
  const elementA = document.createElement('a');
  elementA.download = `${filename}.jpg`;
  elementA.style.display = 'none';
  elementA.href = typeof blob === 'string' ? blob : URL.createObjectURL(blob);
  document.body.appendChild(elementA);
  elementA.click();
  document.body.removeChild(elementA);
}

/** 下载跨域图片(cos桶的也是) */
export function downloadCorsImg(img: HTMLImageElement, filename: string) {
  // ios 4k以上的Canvas画不出来
  // if (img.height > 4000 && isIOS(navigator.userAgent) && window.location.search.includes('open')) {
  //   const a = document.createElement('a');
  //   a.download = `${filename}.jpg`;
  //   a.href = img.src;
  //   a.click();
  //   return;
  // }
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const r = window.devicePixelRatio || 2;
  canvas.width = Math.floor(img.width * r);
  canvas.height = Math.floor(img.height * r);
  context!.drawImage(img, 0, 0, img.width * r, img.height * r);
  context!.scale(r, r);
  const url = canvas.toDataURL('images/jpg');
  const a = document.createElement('a');
  const event = new MouseEvent('click');
  a.download = `${filename}.jpg`;
  a.href = url;
  a.dispatchEvent(event);
}

/** 将dom生成图片blob */
export const takeScreenshot = (dom: HTMLDivElement) =>
  // processSvgSymbol(dom);
  new Promise<Blob>((resolve, reject) => {
    html2canvas(dom, {
      x: 0,
      y: 0,
      scale: 2,
      useCORS: true,
    })
      .then((canvas) => {
        if (!canvas) throw 'canvas undefined';
        canvas.toBlob(
          (blob) => {
            resolve(blob!);
          },
          'image/png',
          1,
        );
      })
      .catch((e) => {
        reject(e);
      });
  });

export const blob2Base64 = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob!);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
